import { z } from "zod";

export const WoodGrainTuningSchema = z.object({
  fsm_conf_high: z.number().min(0).max(1).default(0.60),
  fsm_conf_low: z.number().min(0).max(1).default(0.40),
  kalman_q: z.number().positive().default(0.05),
  kalman_r: z.number().positive().default(10.0),
  coast_timeout_ms: z.number().positive().default(500),
});

export type WoodGrainTuningProfile = z.infer<typeof WoodGrainTuningSchema>;
export const DEFAULT_WOOD_GRAIN: WoodGrainTuningProfile = WoodGrainTuningSchema.parse({});
